import { createI18n } from "vue-i18n"
import { cookiesService, TRANSLATIONS_COOKIE } from "@/services/cookies.service"
import translationsService from "@/services/translations.service"
import { localStorageService } from "@/services/localStorage.service"

import SmartPageLocales from "../components/SmartPageRenderer/locales"

const I18N_LOCALE = "en"
const I18N_FALLBACK_LOCALE = "en"
const TRANSLATIONS_ENABLED = ["en", "es", "pt-BR"]
const DEFAULT_LOCALE = "en"

export const i18n = createI18n({
  locale: I18N_LOCALE,
  fallbackLocale: I18N_FALLBACK_LOCALE,
  legacy: false,
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  warnHtmlMessage: false,
  warnHtmlInMessage: "off",
  messages: {
    ...SmartPageLocales
  }
})

setI18nLocale(DEFAULT_LOCALE)

export async function loadTranslations({ forceLoadFromBackend = false }) {
  const storeTranslations = localStorageService.getTranslations()
  let translations = JSON.parse(storeTranslations)

  if (
    !cookiesService.checkIfExist(TRANSLATIONS_COOKIE) ||
    !storeTranslations ||
    forceLoadFromBackend
  ) {
    const response = await translationsService.getAll()
    translations = response.items
    cookiesService.createTranslationsCookie()
  }

  localStorageService.setTranslations(JSON.stringify(translations))
  Object.keys(translations).forEach((lang) => {
    i18n.global.setLocaleMessage(lang, {
      ...i18n.global.getLocaleMessage(lang),
      ...translations[lang]
    })
  })
}

/**
 * Updates the locale locale jus language Only if it is a valid language,
 * else set the default language (es)
 * @param {*} newValue  // recive new lang
 * @returns new locale
 */
export function setI18nLocale(newValue) {
  let isLangValid = (lang) => TRANSLATIONS_ENABLED.includes(lang)
  let [userLanguage] = window.navigator.language.split("-")
  let _newValue = newValue ?? userLanguage
  let locale =
    {
      en: "en",
      es: "es",
      "pt-BR": "ptBr"
    }[_newValue] ?? DEFAULT_LOCALE

  const lang = isLangValid(_newValue) ? locale : DEFAULT_LOCALE
  localStorage.setItem("locale", lang)
  i18n.global.locale.value = lang
}

export default i18n
